import { render, staticRenderFns } from "./AgentIndex.vue?vue&type=template&id=29058159"
import script from "./AgentIndex.vue?vue&type=script&lang=js"
export * from "./AgentIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports